import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import MyLoadingButton from "../../../../components/buttons/MyLoadingButton";
import NewUserForm from "../../../../components/modals/bookingModalComponents/components/NewUserForm";
import CustomDialog from "../../../../components/wrappers/CustomDrawer";
import { ToggleDrawerContext } from "../../../../contexts/ToggleDrawer";
import { USERS_CLINIC } from "../../../../enums/QueryKeys";
import usePut from "../../../../hooks/usePut";
import useUser from "../../../../hooks/useUser";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import ConfirmAndCancelButtons from "../../../../components/buttons/ConfirmAndCancelButtons";

export default function NewUserFormComponent() {
  const methods = useForm();
  const { roles } = useUser();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useContext(ToggleDrawerContext);
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const post = usePut("/users/create/newUser", USERS_CLINIC, USERS_CLINIC);

  async function submitNewUser(e) {
    var submitObj = {
      ...e?.user?.userDetails,
    };
    if (roles.master) {
      if (e?.clinic == null || e?.clinic == undefined) {
        methods.setError("clinic", {
          type: "custom",
          message: t("PleaseChooseAClinic"),
        });
        handleSnackbar("PleaseChooseAClinic", "error");
        return false;
      }
      submitObj.clinicId = e?.clinic?.id;
    }
    const res = await post.submitCallback(submitObj);
    if (res == true) {
      setIsOpen(false);
      const fields = [
        "user.userDetails.firstName",
        "user.userDetails.lastName",
        "user.userDetails.email",
        "user.userDetails.phoneNumber",
        "user.userDetails.sendEmailNotifications",
        "clinic",
      ];
      fields.forEach((field) => methods.resetField(field));
    }
  }

  return (
    <CustomDialog
      buttonSize={"small"}
      buttonVariant="contained"
      color="primary"
      buttonMessage={t("NewUser")}
      testId="users.page.new-user"
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(submitNewUser)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">{t("AddNewUser")}</Typography>
            </Grid>
            <NewUserForm />
            <Grid item xs={12}>
              <ConfirmAndCancelButtons
                useCustomLoadingButtonOnConfirm={true}
                isConfirmLoading={post.isLoading}
                confirmTitle="Add"
                cancelTitle="Cancel"
                onCancel={() => setIsOpen(false)}
                confirmButtonType="submit"
                testId="users.new-user-form"
              />
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </CustomDialog>
  );
}
